import { companySchema } from "@/components/Forms/schema/companySchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceSelector } from "jsonapi-zod-query";

const companySelector = createResourceSelector({
    type: "company",
    attributesSchema: companySchema,
});

export type Person = ReturnType<typeof companySelector>;

type Props = {
    placeId: string;
    isQueryEnabled?: boolean;
};
export const useFetchCompany = ({
    placeId,
    isQueryEnabled = true,
}: Props): UseQueryResult<Person> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        enabled: isQueryEnabled,
        queryKey: ["place", placeId],
        queryFn: async ({ signal }) => {
            const url = apiUrl(`/company/${placeId}`);

            const response = await fetch(url, {
                signal,
                headers: {
                    accept: "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: companySelector,
    });
};
